/** (组织机构管理页)查询、新增、删除、修改
 */
const orgCtl = {
  /** 删除组织机构信息
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param orgId {string} 组织ID
   */
  delOrgById: function (_this, url, data) {
    _this.$axios({
      method: 'post',
      url: url,
      data: data,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        _this.$message({
          message: resp.data.message,
          type: 'success'
        })
        _this.refreshTree()
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'error'
        })
      }
    }).catch(resp => {
      console.log('删除失败！' + resp)
    })
  },
  /** 新建组织
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param data {string} form表单数据
   */
  addOrganization: function (_this, url, data) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
        orgName: data.orgName,
        orgNo: data.orgNo,
        orgPid: data.orgPid,
        orgPids: data.orgPids
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        if (typeof (resp.data.data) === 'number' && resp.data.data == 1) {
          _this.$message({
            message: resp.data.message,
            type: 'success'
          })
          _this.creatOrgDialogFormVisible = false
          _this.$refs.creatFrom.resetFields()
          _this.$parent.refreshTree()
        } else {
          _this.$message({
            message: resp.data.data.message,
            type: 'error'
          })
        }
      } else {
        _this.$message({
          message: resp.data.message,
          type: 'warning'
        })
      }
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  }
}

export default orgCtl



// WEBPACK FOOTER //
// ./src/javascript/function/organizationFunction.js